import React from "react";
import classes from "./DataHubTitle.module.css";

const DataHubTitle = () => {
  return <h2 className={classes.title}>Data Hub</h2>;
};

export default DataHubTitle;
